/**
 * <gender-toggle> - MEN/WOMEN-vaelgeren (BUILD_PLAN 9.1). Klik saetter det
 * valgte koen i localStorage ('kca:gender') og flipper html[data-gender]
 * LIVE - audience-taggede sektioner og de koensdelte nav-menuer skifter
 * uden reload (ren CSS, base.css). Alle toggle-instanser (header + drawer)
 * synkroniseres via aria-current.
 *
 * Progressive enhancement: uden JS er valgene almindelige links til
 * settings.men_url/women_url (koens-kollektionerne); pre-paint-scriptet i
 * theme.liquid har allerede sat data-gender ud fra gemt valg/side-audience.
 */
class GenderToggle extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const choice = event.target.closest('[data-gender-choice]');
      if (!choice) return;
      event.preventDefault();
      const gender = choice.dataset.genderChoice === 'women' ? 'women' : 'men';
      try {
        localStorage.setItem('kca:gender', gender);
      } catch (e) {
        /* private mode: valget gaelder saa kun til navigation */
      }
      document.documentElement.setAttribute('data-gender', gender);
      GenderToggle.syncAll();
      this.#announce(choice);
    });
    GenderToggle.syncAll();
  }

  /**
   * Annoncer skiftet. aria-current alene er tavst: den laeses ved FOKUS, og
   * fokus staar allerede paa det klikkede link, saa hele kategoriskiftet
   * sker uden en lyd. Teksten er faerdigoversat i data-announce (serveren
   * ejer sproget), og KUN den klikkede instans annoncerer - header og drawer
   * har hver sit omraade, saa den skjulte af dem ikke dublerer beskeden.
   */
  #announce(choice) {
    const live = this.querySelector('[data-gender-live]');
    if (!live || !choice.dataset.announce) return;
    live.textContent = choice.dataset.announce;
  }

  // aria-current paa det aktive valg - paa tvaers af alle instanser.
  static syncAll() {
    const gender = document.documentElement.getAttribute('data-gender') || 'men';
    document.querySelectorAll('[data-gender-choice]').forEach((el) => {
      if (el.dataset.genderChoice === gender) {
        el.setAttribute('aria-current', 'true');
      } else {
        el.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('gender-toggle')) {
  customElements.define('gender-toggle', GenderToggle);
}
